import { Navigate } from "react-router-dom";

const Projects = () => <Navigate to="/portfolio" replace />;

export default Projects;
